import { NgModule } from '@angular/core';
import {Routes, RouterModule, PreloadAllModules} from '@angular/router';
import { AuthGuard } from './app-shared/services/auth.guard';

const routes: Routes = [
  {
    path: 'start',
    loadChildren: () => import('./start/start.module').then((m) => m.StartModule),
  },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  {
    path: '',
    loadChildren: () => import('./core/core.module').then((m) => m.CoreModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'suppliers',
    loadChildren: () =>
      import('./suppliers-outlets/suppliers-outlets.module').then(
        (m) => m.SuppliersOutletsModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'activate-outlet',
    loadChildren: () =>
      import('./activate-outlet/activate-outlet.module').then(
        (m) => m.ActivateOutletModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'activate-catalog',
    loadChildren: () =>
      import('./auto-activate-catalog/auto-activate-catalog.module').then(
        (m) => m.AutoActivateCatalogModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminModule),
    canActivate: [AuthGuard],
  },
  { path: '**', redirectTo: '/suppliers' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      scrollOffset:[0,0],
      preloadingStrategy: PreloadAllModules
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
